import { render, staticRenderFns } from "./PrListTab.vue?vue&type=template&id=1e035174&scoped=true"
import script from "./PrListTab.vue?vue&type=script&lang=js"
export * from "./PrListTab.vue?vue&type=script&lang=js"
import style0 from "./PrListTab.vue?vue&type=style&index=0&id=1e035174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e035174",
  null
  
)

export default component.exports